export default __webpack_public_path__ + "static/media/pembelian.a5fdf07f.png";